import React, { useEffect, useRef, useState } from 'react';
import DashboardStyle from './styled';
import images from 'src/assets/image';
import icons from 'src/assets/icon';
import ViewTableComponent from './listQuotesComponent/index';
import { useDispatch } from 'react-redux';
import { authExited } from 'src/redux/actions/authenAction';
import { useNavigate, useLocation } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import { getFirstLetter } from 'src/const/contain';
import VersionModal from './listQuotesComponent/VersionModal';
import packageJson from '../../../package.json';

const DashboardComponent = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const token = localStorage.getItem('access_token');
    const [show, setIsShow] = useState<boolean>(false);
    const dropdownRef = useRef<HTMLDivElement>(null);
    const location = useLocation();
    const containsRevisionHistory =
        location.pathname.includes('revisionHistory');
    const match = location.pathname.match(/revisionHistory\/(\d+)/);
    const revisionId = match ? match[1] : null;
    const [fullName, setFullName] = useState<string>('');
    const [jobTitle, setJobTitle] = useState<string>('');
    const [takeFirst, setTakeFirst] = useState<string>('');

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (
                dropdownRef.current &&
                !dropdownRef.current.contains(event.target as Node)
            ) {
                setIsShow(false);
            }
        };
        document.addEventListener('click', handleClickOutside);
        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, [dropdownRef]);

    useEffect(()=> {
        if (token) {
            const getProfile = jwtDecode(`${token}`) as {
                family_name: string;
                given_name: string;
                job_title: string;
            };
            setFullName(`${getProfile?.given_name} ${getProfile?.family_name}`);
            setJobTitle(getProfile?.job_title);
            setTakeFirst(getFirstLetter(getProfile?.given_name || ''));
        }
    },[token])

    const logOutBtn = () => {
        localStorage.removeItem('access_token');
        localStorage.removeItem('refresh_token');
        dispatch(authExited(false));
        navigate('/login');
    };
    const showDropdown = () => {
        setIsShow(!show);
    };

    const comeDashBoard = () =>{
        navigate('/dashboard');
    }

    return (
        <DashboardStyle>
            <div className="menuDashboard">
                <img alt="" className="LogoIMG" src={images.logoYGT} />
                <div className="menuBtn" onClick={comeDashBoard}>
                    <div className="btnQuotes">
                        <div className="groupBtnQuote">
                            <img
                                alt=""
                                className="iconfile"
                                src={icons.iconFile}
                            />
                            <div>Quotes</div>
                        </div>
                        <img
                            alt=""
                            className="iconfile"
                            src={icons.arrowRight}
                        />
                    </div>
                </div>
                <div
                    className="btmAdmin"
                    onClick={showDropdown}
                    ref={dropdownRef}
                >
                    <div className="groupBtnQuote">
                        <div className="avatar">{takeFirst}</div>
                        <div className="groupJobTitleAndName">
                            <div className="nameSeller">{fullName}</div>
                            <div className="position">{jobTitle}</div>
                        </div>
                    </div>
                    <img alt="" className="iconfile" src={icons.arrowDown} />
                </div>
                {show && (
                    <div id="myDropdown" className="dropdown-content-login">
                        <div className="logOutBtn" onClick={logOutBtn}>
                            Log out
                        </div>
                    </div>
                )}
                <div className='version'>Version {packageJson.version}</div>
            </div>
            <div className="tableDashboard">
                <div className="headerTable">
                    <div className="showNameSeller">Hi {fullName}</div>
                </div>

                <div className="table">
                    {!containsRevisionHistory ? (
                        <ViewTableComponent />
                    ) : (
                        <VersionModal idQuote={revisionId}/>
                    )}
                </div>
            </div>
        </DashboardStyle>
    );
};

export default DashboardComponent;
